import { render, staticRenderFns } from "./BaggageReturn.vue?vue&type=template&id=a9c9040e&scoped=true"
import script from "./BaggageReturn.vue?vue&type=script&lang=js"
export * from "./BaggageReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c9040e",
  null
  
)

export default component.exports